
(function () {

  const script = document.currentScript;
  const dataTarget = script.getAttribute('data-target');

  const section = document.querySelector(dataTarget)
  const swiper = section.querySelector('.swiper')

  const nextEl = section.querySelector('.collection-list__swiper-button--next')
  const prevEl = section.querySelector('.collection-list__swiper-button--prev')
  const pagination = section.querySelector('.collection-list__swiper-pagination')

  const collectionListSlider = new Swiper(swiper, {
    slidesPerView: 'auto',
    spaceBetween: 20,
    navigation: {
      nextEl: nextEl,
      prevEl: prevEl,
    },
    pagination: {
      el: pagination,
      clickable: true,
    },
  });

})()